<template>
  <v-container>
    <Table
      module="Cleaning"
      :items="allAudits"
      title="Cleaning Audits"
      :headers="headers"
      :totalItems="totalItems"
      sortKey="dateCreated"
      expand
    >
      <template v-slot:data="{props}">
        <tr
          @click="iconActive = true;"
          :class="props.expanded ? 'primary lighten-1 elevation-1' : ''"
        >
          <td
            class="text-xs-center pr-0"
            @click="props.item.remarks ? props.expanded =  !props.expanded : null"
          >
            <v-icon
              medium
              :class="!iconActive ? 'remove-animation' : !props.expanded ? 'table-icon-rotate-right' : 'table-icon-rotate-left'"
              :disabled="!props.item.remarks"
            >{{!props.expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}</v-icon>
          </td>
          <td
            @click="props.item.remarks ? props.expanded =  !props.expanded : null"
          >{{localizeDate(props.item.dateCreated, true)}}</td>
          <td
            @click="props.item.remarks ? props.expanded =  !props.expanded : null"
          >{{ props.item.productCategory }}</td>
          <td
            @click="props.item.remarks ? props.expanded =  !props.expanded : null"
          >{{ props.item.quantityGiven }}</td>
          <td
            @click="props.item.remarks ? props.expanded =  !props.expanded : null"
          >{{ props.item.quantityReceived }}</td>
          <td
            @click="props.item.remarks ? props.expanded =  !props.expanded : null"
          >{{ props.item.quantityLeft }}</td>
          <td
            @click="props.item.remarks ? props.expanded =  !props.expanded : null"
          >{{ props.item.quantityNew }}</td>
          <td
            @click="props.item.remarks ? props.expanded =  !props.expanded : null"
          >{{ props.item.quantityCertified }}</td>
          <td
            @click="props.item.remarks ? props.expanded =  !props.expanded : null"
          >{{ props.item.quantityRefurbished }}</td>
          <td
            @click="props.item.remarks ? props.expanded =  !props.expanded : null"
          >{{ props.item.quantityPreowned }}</td>
          <td
            @click="props.item.remarks ? props.expanded =  !props.expanded : null"
          >{{ props.item.quantityBroken }}</td>
          <td
            @click="props.item.remarks ? props.expanded =  !props.expanded : null"
          >{{ props.item.quantityWrong }}</td>
          <td
            @click="props.item.remarks ? props.expanded =  !props.expanded : null"
          >{{ props.item.auditor ? props.item.auditor.name : "" }}</td>
          <td
            @click="props.item.remarks ? props.expanded =  !props.expanded : null"
          >{{ props.item.employee ? props.item.employee.name : "" }}</td>
          <td
            @click="props.item.remarks ? props.expanded =  !props.expanded : null"
          >{{ localizeDate(new Date(props.item.auditDate).setDate(new Date(props.item.auditDate).getDate() + 1)) }}</td>
          <td>
            <v-icon class="mr-2" small @click="editRow(props.item)">edit</v-icon>
            <v-icon small @click="deleteRow(props.item)">delete</v-icon>
          </td>
        </tr>
      </template>

      <template v-slot:expansion="{props}">
        <v-card
          v-if="props.expanded && props.item.remarks"
          color="primary lighten-1"
          class="elevation-1"
          :style="{minHeight: '8vh'}"
          :key="props.index"
        >
          <v-card-title class="pb-0">
            <h3>Extra Remarks:</h3>
          </v-card-title>
          <v-card-text>
            <h4>{{props.item.remarks}}</h4>
          </v-card-text>
        </v-card>
      </template>
    </Table>
    <Create v-model="createView" />

    <v-btn fab fixed bottom right icon color="secondary" @click="createView = true">
      <v-icon large>add</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import LoginCheck from "@/mixins/LoginCheck";
import Table from "@/components/app/Table";
import Create from "@/components/audits/cleaning/Create";
import Common from "@/mixins/Common";

export default {
  name: "Cleaning",

  components: {
    Table,
    Create
  },

  data() {
    return {
      createView: false,
      headers: [
        { text: "", value: "", sortable: false },
        { text: "Date Created", value: "dateCreated" },
        { text: "Category", value: "productCategory" },
        { text: "Given", value: "quantityGiven" },
        { text: "Received", value: "quantityReceived" },
        { text: "Unfinished", value: "quantityLeft" },
        { text: "New", value: "quantityNew" },
        { text: "Certified", value: "quantityCertified" },
        { text: "Refurbished", value: "quantityRefurbished" },
        { text: "Pre-Owned", value: "quantityPreowned" },
        { text: "Broken", value: "quantityBroken" },
        { text: "Wrong Model", value: "quantityWrong" },
        { text: "Auditor", value: "auditor.name" },
        { text: "Employee", value: "employee.name" },
        { text: "Audit Date", value: "auditDate" },
        { text: "Actions", value: "", sortable: false }
      ],
      iconActive: false
    };
  },

  computed: {
    ...mapGetters({
      allAudits: "audits/getAllAudits",
      user: "app/getUser",
      totalItems: "audits/getTotalAudits"
    })
  },

  destroyed() {
    this.$store.commit("audits/setAllAudits", []);
    this.$store.commit("audits/setCategories", []);
  },

  mixins: [LoginCheck, Common],

  methods: {
    editRow(row) {
      if (
        this.user._groups.includes("Admins") ||
        this.user.displayName === row.auditor.name
      ) {
        this.createView = true;
        this.$store.commit("audits/setEditAudit", row);
      } else {
        window.alert(
          "You do not have permission to edit this. Please contact an Administrator or the Auditor."
        );
      }
    },
    async deleteRow(row) {
      if (
        this.user._groups.includes("Admins") ||
        this.user.displayName === row.auditor.name
      ) {
        let confirmText = `Are you sure you want to delete this? It can not be recovered!`;
        if (confirm(confirmText)) {
          await this.$store.dispatch("audits/delete", {
            module: "cleaning",
            id: row._id
          });
          await this.$store.dispatch("audits/getAllAudits", {
            rowsPerPage: 10,
            sortBy: "dateCreated",
            descending: true,
            page: 1,
            from: null,
            to: null,
            search: null,
            module: "cleaning"
          });
        }
      } else {
        window.alert(
          "You do not have permission to delete this. Please contact an Administrator or the Auditor."
        );
      }
    }
  }
};
</script>

<style scoped>
>>> .v-table.theme--dark tr:hover {
  cursor: pointer;
}
</style>